export function relativeTime(epochSeconds) {
    const now = Date.now() / 1000;
    const diff = Math.floor(now - epochSeconds);

    const plural = (n, singular, plural) => `${n} ${n === 1 ? singular : plural} fa`;

    if (diff < 60)           return "Ora";
    if (diff < 3600)         return plural(Math.floor(diff / 60), "minuto", "minuti");
    if (diff < 86400)        return plural(Math.floor(diff / 3600), "ora", "ore");
    if (diff < 86400 * 30)   return plural(Math.floor(diff / 86400), "giorno", "giorni");
    if (diff < 86400 * 365)  return plural(Math.floor(diff / (86400 * 30)), "mese", "mesi");
    return plural(Math.floor(diff / (86400 * 365)), "anno", "anni");
}


